import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Card from "../components/Card"

import '../components/theme.js'

const IndexPage = () => (
  
  <Layout>
    <SEO title="Home" />
    <div className="Hero">
      <h1>Red Design <span>Darkmode</span> <br />Exploring</h1>
      <h3>New Feature！New Appearance!</h3>
      <h4>- Theme Choice -</h4>
      <div className="ThemeChoice">
        <div className="ThemeLight">
          <button data-theme-type="light">🌝 Light</button>
        </div>
        <div className="ThemeDark">
          <button data-theme-type="dark">🌚 Dark</button>
        </div>     
      </div>
      
      <div className="Exploring">
        <h3>Start Your Journail</h3>  
        <p>///-- Earth Time: 2019.10.30 --///</p>
        <img src={require('../images/astronaut.png')}/>
      </div> 
    </div>
  <div className="SectionColletions">
  
    <div className="Section">
      <div className="SectionInfo">
          <button>Darkmode Experience</button>
          <h4>Review Mobile New Interface</h4>
          <div className="SectionMockupImage">
              <img src={require('../images/surface.png')} />
              <video x5-video-player-type="h5" width="400" height="592" autoPlay muted loop playsInline>
                <source src={require('../images/Red_Darkmode.mp4')} type="video/mp4"/>
              </video>
          </div>
        </div>
    </div>

    <div className="Section">
      <div className="SectionInfo">
          <button>Color Palette</button>
          <h4>通过定义 Light 和 Dark 模式下的基础颜色名称，保证色彩的一键切换</h4>
            <div className="ColorCube">
            <p>///-- Netural Color --///</p>
            <div className="ColorStyle">
              <div className="color1"></div>
              <div className="color2"></div>
              <div className="color3"></div>
              <div className="color4"></div>
              <div className="color5"></div>
              <div className="color6"></div>
              <div className="color7"></div>
              <div className="color8"></div>
              <div className="color9"></div>
              <div className="color10"></div>
            </div>
            <div className="ColorStyleName">
              <p>GaryLevel1</p>
              <p>GaryLevel2</p>
              <p>GaryLevel3</p>
              <p>GaryLevel4</p>
              <p>GaryLevel5</p>
              <p>GaryLevel6</p>
              <p>GaryLevel7</p>
              <p>GrayPath1</p>
              <p>GrayPath2</p>
              <p>WhitePath1</p>
           </div>
          </div>
          
        </div>
    </div>


    <div className="Section">
      <div className="SectionInfo">
        <button>Design Process</button>
        <h4>通过文档形式的交付方式，保证设计师和研发交付的统一性<br />确保中途参与的人员能够在理解整体流程基础上进行工作的快速展开</h4>
      </div>
      <div className="SectionCard">
      <Link to="/Blog">
        <Card
          img="https://p13.f2.n0.cdn.getcloudapp.com/items/yAuLxYjP/thumbinal_space.png?v=52630a3f9d99a76a634f25c4788d90d5"
          title="Red Darkmode Proposal"
          avatar="https://p13.f2.n0.cdn.getcloudapp.com/items/9ZuNrP6A/yhmnin.png?v=fafa982452ea23295af3bd00e0e040b6"
          datatime="2019.10.10"
          subtitle="Project Description"
          text="众所周知，随着 iOS 13 和 Android Q 的相继发布，对于 Darkmode 的支持变成了应用层的一个特性。通过对 Apple 和 Android 规范的梳理和已适配深色模式的产品分析进行系统性总结，探索输出能够满足小红书深色模式的整体定义和色彩规范文件，有序的开展 Darkmode 的..."
          />
   
   </Link>
        <Card
          img="https://p13.f2.n0.cdn.getcloudapp.com/items/L1ukxpPO/thumbnail_colorful.png?v=2abd7ffd4ea94607920538d6870a0c1b"
          title="Design System Proposal"
          avatar="https://p13.f2.n0.cdn.getcloudapp.com/items/9ZuNrP6A/yhmnin.png?v=fafa982452ea23295af3bd00e0e040b6"
          datatime="2019.08.12"
          subtitle="Project Description"
          text="通过建立 Design System 的方式保证设计体系完善性和研发成本的可控性，设计侧从色彩层出发进行了探索，在符合当前品牌传达的基础上，定义 Primary、Secondary、Neutral 等颜色来保证整体 App 的良好体验。同时对于使用细节和二种模式兼容性的角度进行思考，希望能够呈..."
          />
        
        <Card
          img="https://p13.f2.n0.cdn.getcloudapp.com/items/P8uYjep6/thumbnail_workspace.png?v=066e9f03b612f570837fb16514c1d551"
          title="Team Cooperation"
          avatar="https://p13.f2.n0.cdn.getcloudapp.com/items/9ZuNrP6A/yhmnin.png?v=fafa982452ea23295af3bd00e0e040b6"
          datatime="2019.06.30"
          subtitle="Project Description"
          text=" 对于角色定位的问题曾经一直有所困扰，但当真的一个项目从产出到落地的具体环节中，对于资源的合理配置和流程的思考，让我越发明白设计师的职业划分是多么的狭隘，只有不断的从自身的实际情况出发，并作出相应的对策调整方案，才能够将项目更好更快的进行实际的落地..."
          />
        </div>
    </div>

    <div className="DesignerAvatar">
    <div className="SectionInfo">
          <button>Team Cooperation</button>
          <h3>👩🏻‍💻 Designers 👨🏻‍💻</h3>
        </div>
        <div className="AvtarCollection">
          <img src={require('../images/avatar_af.png')} />
            <img src={require('../images/avatar_be.png')} />
            <img src={require('../images/avatar_flk.png')} />
            <img src={require('../images/avatar_gg.png')} />
            <img src={require('../images/avatar_jz.png')} />
            <img src={require('../images/avatar_lan.png')} />
            <img src={require('../images/avatar_lg.png')} />
            <img src={require('../images/avatar_ml.png')} />
            <img src={require('../images/avatar_qbt.png')} />
            <img src={require('../images/avatar_qz.png')} />
            <img src={require('../images/avatar_snp.png')} />
            <a href="https://dribbble.com/SUNsun74" target="toblank"><img src={require('../images/avatar_xxt.png')} /></a>
            <a href ="https://twitter.com/yhmnin" target="toblank"><img src={require('../images/yhmnin.png')} /></a>
        </div>
          
    </div>
   
    <div className="Section">
      <div className="SectionInfo">
          <h2>What About Next?</h2>
          <h3>🕹 重新考虑的设计思路 🕹</h3>
          <div className="Thought">
          <p>无边框的设计思路<br />AR VR 等新技术的普及和新颖玩法<br />5 G 时代的到来，图片和视频消费的体验升级（极高的速率、极大的容量、极低的时延）<br />品牌战略化部署，专注于小红书品牌调性和用户增长的契合点考虑</p>
          </div>
          <div className="PhoneImageview">
            <img src={require('../images/iPad Pro - Apple.png')} width="960"></img>
          </div>
        </div>
    </div>
    

    </div>
    <div className="SectionCube">
    </div>
  </Layout>
)

export default IndexPage

